import { useQuery } from '@tanstack/react-query';
import {
  GetAllReferralsEntity,
  ReferralProgramService,
} from 'services/openapi';
import { ReferrallQueryKeys } from './constants';

type GetListTransPointDTO = {
  page: string;
  pageSize: string;
};

export const useGetReferralTransactionExportQuery = (
  variables: GetListTransPointDTO,
) => {
  const queryKey = [ReferrallQueryKeys.GET_REFERRAL_TRANSACTION, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetAllReferralsEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      ReferralProgramService.referralProgramControllerGetAllReferrals(
        variables.page,
        variables.pageSize,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
